import { CardContent, Stack, TextField, Typography } from "@mui/material"
import { useContext } from "react"
import { MainContext } from "../../../controllers/main"
import { TagsContext } from "../../../controllers/tags"

const TopicTranslationsEdit = ({
  itemIndex,
  errors,
}: {
  itemIndex: number
  errors: { type: string; error: boolean }[]
}) => {
  const { showPadding } = useContext(MainContext)
  const { currentTopic, setCurrentTopic, editMode } = useContext(TagsContext)

  // current item
  const currentItem = currentTopic.translations[itemIndex]

  // errors
  const nameError = errors.find(
    (item) => item.type === "name" + currentTopic.translations[itemIndex].lang
  ).error

  return (
    <CardContent
      style={{
        height:
          showPadding === "yes" ? "calc(100vh - 200px)" : "calc(100vh - 183px)",
        maxHeight:
          showPadding === "yes" ? "calc(100vh - 200px)" : "calc(100vh - 183px)",
        overflowY: "scroll",
      }}
    >
      <Stack spacing={2}>
        <Typography variant="h6" className="card-title">
          Details
        </Typography>
        <TextField
          fullWidth
          size="small"
          label="Name"
          value={currentItem.name}
          onChange={(e) => {
            currentTopic.translations[itemIndex].name = e.target.value
            setCurrentTopic({ ...currentTopic })
          }}
          onBlur={(e) => {
            currentTopic.translations[itemIndex].name =
              currentTopic.translations[itemIndex].name.trim()
            setCurrentTopic({ ...currentTopic })
          }}
          disabled={!editMode}
          error={nameError}
          helperText={nameError ? "This field is required" : ""}
        />
      </Stack>
    </CardContent>
  )
}

export default TopicTranslationsEdit
